<template>
  <div>
    <el-dialog
      :title="$t('面板自检')"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="900px"
      :custom-class="customClass"
    >
      <div class="check-dialog-body">
        <div class="check-filter-row">
          <el-date-picker
            v-model="checkDateRange"
            @change="onFilterChange"
            type="daterange"
            format="yyyy-MM-dd"
            :clearable="false"
            range-separator="至"
            :start-placeholder="$t('开始日期')"
            :end-placeholder="$t('结束日期')"
          ></el-date-picker>
          <el-select
            v-model="errFlagFilter"
            @change="onFilterChange"
            :placeholder="$t('异常类型')"
            clearable
            class="check-type-filter"
          >
            <el-option
              v-for="item in errFlagOptions"
              :key="item.value"
              :label="$t(item.label)"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="check-summary-row">
        <span v-if="errTotal > 0" class="check-summary-err">
          {{ $t('共检测') }} {{ devTotal }} {{ $t('台面板，异常') }} {{ errTotal }} {{ $t('台') }}
        </span>
          <span v-else class="check-summary-ok">
          {{ $t('共检测') }} {{ devTotal }} {{ $t('台面板，未发现异常') }}
        </span>
        </div>
        <!-- 表格容器自动占满剩余空间 -->
        <div class="check-table-wrapper">
          <el-table
            :data="checkTableData"
            border
            style="width:100%; font-size:11px;"
            height="100%"
            show-overflow-tooltip
            :header-cell-style="checkHeaderCellStyle"
            :cell-style="checkCellStyle"
            @row-click="openDetail"
          >
            <el-table-column width="60" type="index" :label="$t('序号')" align="center"></el-table-column>
            <el-table-column
              v-for="d in checkDefHead"
              :key="d.val"
              :prop="d.val"
              :label="$t(d.key)"
              sortable
            ></el-table-column>
            <el-table-column width="70" :label="$t('操作')" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click.stop="openDetail(scope.row)">{{ $t('详情') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="check-pagination-row">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[20, 30, 50, 100]"
            :page-size="pageSize"
            layout="sizes, total, prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </div>
      <div slot="footer" class="dialog-custom-footer">
        <button class="close-btn" @click="dialogVisible = false">{{ $t('关闭') }}</button>
      </div>
    </el-dialog>
    <!-- 单台设备异常详情弹窗 -->
    <el-dialog
      :title="$t('异常详情')"
      :visible.sync="detailVisible"
      :close-on-click-modal="false"
      width="900px"
      append-to-body
      :custom-class="customClass"
    >
      <div class="check-dialog-body">
        <div class="check-summary-row">
        <span class="check-detail-title">
          {{ detailDev.area_name }}{{ detailDev.building_name }}{{ detailDev.floor_name }}{{ detailDev.room_name }}
          {{ detailDev.dev_name }}（{{ detailDev.wg_mac }} / {{ detailDev.wg_qid }}），{{ $t('共') }} {{
            detailTotal
          }} {{ $t('条异常记录') }}
        </span>
        </div>
        <div class="check-table-wrapper detail-table-wrapper">
          <el-table
            :data="detailTableData"
            border
            style="width:100%; font-size:11px;"
            height="100%"
            show-overflow-tooltip
            :header-cell-style="checkHeaderCellStyle"
            :cell-style="checkCellStyle"
          >
            <el-table-column width="60" type="index" :label="$t('序号')" align="center"></el-table-column>
            <el-table-column
              v-for="d in detailDefHead"
              :key="d.val"
              :prop="d.val"
              :label="$t(d.key)"
            ></el-table-column>
            <el-table-column :label="$t('原始帧')" min-width="200" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class="frame-cell">{{ scope.row.frame }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="check-pagination-row">
          <el-pagination
            @size-change="detailSizeChange"
            @current-change="detailCurrentChange"
            :current-page="detailPage"
            :page-sizes="[20, 30, 50, 100]"
            :page-size="detailPageSize"
            layout="sizes, total, prev, pager, next"
            :total="detailTotal"
          ></el-pagination>
        </div>
      </div>
      <div slot="footer" class="dialog-custom-footer">
        <button class="close-btn" @click="detailVisible = false">{{ $t('关闭') }}</button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment/moment';

export default {
  name:'DiaDevCheck',
  props:{
    visible:{
      type:Boolean,
      default:false
    },
    /* 主题标识：'1' 为浅色主题，其它为深色主题 */
    bj:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      page:1,
      pageSize:30,
      total:0,
      devTotal:0,
      errTotal:0,
      checkDateRange:[],
      checkTableData:[],
      checkDefHead:[
        {key:'区域',val:'area_name'},
        {key:'楼栋',val:'building_name'},
        {key:'楼层',val:'floor_name'},
        {key:'房间',val:'room_name'},
        {key:'设备名称',val:'dev_name'},
        {key:'异常类型',val:'err_msg'},
        {key:'异常次数',val:'err_count'},
        {key:'累计时长',val:'sum_runtime'},
        {key:'最近异常时间',val:'uptime'}
      ],
      errFlagFilter:'',
      errFlagOptions:[
        {label:'累计时长回落',value:1},
        {label:'时长增速超限',value:2},
        {label:'疑似地址冲突',value:3}
      ],
      checkLoading:null,
      detailVisible:false,
      detailDev:{},
      detailPage:1,
      detailPageSize:30,
      detailTotal:0,
      detailTableData:[],
      detailDefHead:[
        {key:'异常时间',val:'uptime'},
        {key:'异常类型',val:'err_msg'},
        {key:'累计时长',val:'sum_runtime'},
        {key:'高挡时长',val:'hig_runtime'},
        {key:'中挡时长',val:'mid_runtime'},
        {key:'低挡时长',val:'low_runtime'}
      ],
      detailLoading:null
    };
  },
  computed:{
    dialogVisible:{
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible',val);
      }
    },
    customClass() {
      return this.bj === '1' ? 'dev-check-dialog theme-light':'dev-check-dialog';
    }
  },
  watch:{
    visible(val) {
      if (val) {
        this.page = 1;
        this.pageSize = 30;
        this.total = 0;
        this.devTotal = 0;
        this.errTotal = 0;
        this.errFlagFilter = '';
        this.checkDateRange = this.getLastWeek();
        this.$nextTick(() => {
          this.getCheckData();
        });
      } else {
        this.checkTableData = [];
      }
    }
  },
  methods:{
    onFilterChange() {
      if (!this.checkDateRange || this.checkDateRange.length !== 2) return;
      this.page = 1;
      this.checkLoading = this.$loading({spinner:'',text:this.$t('正在加载中...'),background:'rgba(0, 0, 0, 0.3)'});
      this.getCheckData();
    },
    getCheckData() {
      const params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid'),
        'start_time':this.formatDateTime(this.checkDateRange[0]),
        'end_time':this.formatDateTime(this.checkDateRange[1]),
        'page':this.page,
        'pageSize':this.pageSize
      };
      if (this.errFlagFilter !== '' && this.errFlagFilter !== null) {
        params.err_flag = this.errFlagFilter;
      }
      this.$api.get(this.$urls.ip + this.$urls.get_dev_self_check,params).then(res => {
        if (this.checkLoading) this.checkLoading.close();
        const resData = res.data && res.data.data ? res.data.data:{};
        const lsData = resData.list || [];
        const lData = [];
        for (let i = 0; i < lsData.length; i++) {
          lData.push({
            dev_id:lsData[i]['dev_id'],
            wg_mac:lsData[i]['wg_mac'] || '',
            wg_qid:lsData[i]['wg_qid'] || '',
            area_name:lsData[i]['area_name'] || '',
            building_name:lsData[i]['building_name'] || '',
            unit_name:lsData[i]['unit_name'] || '',
            floor_name:lsData[i]['floor_name'] || '',
            room_name:lsData[i]['room_name'] || '',
            dev_name:lsData[i]['dev_name'] || '',
            err_msg:lsData[i]['err_msg'] || '',
            err_count:lsData[i]['err_count'],
            sum_runtime:lsData[i]['sum_runtime'],
            uptime:lsData[i]['uptime'] || ''
          });
        }
        this.checkTableData = lData;
        this.total = resData.total || lData.length;
        this.devTotal = resData.dev_total || 0;
        this.errTotal = resData.err_total || 0;
      }).catch(error => {
        if (this.checkLoading) this.checkLoading.close();
        this.$message.error(this.$t('获取面板自检结果失败，请稍后重试'));
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.checkLoading = this.$loading({spinner:'',text:this.$t('正在加载中...'),background:'rgba(0, 0, 0, 0.3)'});
      this.getCheckData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.checkLoading = this.$loading({spinner:'',text:this.$t('正在加载中...'),background:'rgba(0, 0, 0, 0.3)'});
      this.getCheckData();
    },
    openDetail(row) { /*点击行：打开单台设备异常详情*/
      this.detailDev = row;
      this.detailPage = 1;
      this.detailTotal = 0;
      this.detailTableData = [];
      this.detailVisible = true;
      this.detailLoading = this.$loading({spinner:'',text:this.$t('正在加载中...'),background:'rgba(0, 0, 0, 0.3)'});
      this.getDetailData();
    },
    getDetailData() { /*查询单台设备全部异常记录（含原始帧）*/
      const params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid'),
        'dev_id':this.detailDev.dev_id,
        'start_time':this.formatDateTime(this.checkDateRange[0]),
        'end_time':this.formatDateTime(this.checkDateRange[1]),
        'page':this.detailPage,
        'pageSize':this.detailPageSize
      };
      if (this.errFlagFilter !== '' && this.errFlagFilter !== null) {
        params.err_flag = this.errFlagFilter;
      }
      this.$api.get(this.$urls.ip + this.$urls.get_dev_self_check_detail,params).then(res => {
        if (this.detailLoading) this.detailLoading.close();
        const resData = res.data && res.data.data ? res.data.data:{};
        const lsData = resData.list || [];
        const lData = [];
        for (let i = 0; i < lsData.length; i++) {
          lData.push({
            uptime:lsData[i]['uptime'] || '',
            err_msg:lsData[i]['err_msg'] || '',
            sum_runtime:lsData[i]['sum_runtime'],
            hig_runtime:lsData[i]['hig_runtime'],
            mid_runtime:lsData[i]['mid_runtime'],
            low_runtime:lsData[i]['low_runtime'],
            frame:lsData[i]['frame'] || ''
          });
        }
        this.detailTableData = lData;
        this.detailTotal = resData.total || lData.length;
      }).catch(error => {
        if (this.detailLoading) this.detailLoading.close();
        this.$message.error(this.$t('获取异常详情失败，请稍后重试'));
      });
    },
    detailSizeChange(val) {
      this.detailPageSize = val;
      this.detailPage = 1;
      this.detailLoading = this.$loading({spinner:'',text:this.$t('正在加载中...'),background:'rgba(0, 0, 0, 0.3)'});
      this.getDetailData();
    },
    detailCurrentChange(val) {
      this.detailPage = val;
      this.detailLoading = this.$loading({spinner:'',text:this.$t('正在加载中...'),background:'rgba(0, 0, 0, 0.3)'});
      this.getDetailData();
    },
    getLastWeek() {
      return [
        new Date(moment().subtract(7,'day').format('YYYY-MM-DD')),
        new Date(moment().format('YYYY-MM-DD'))
      ];
    },
    pad(num) {
      return num.toString().padStart(2,'0');
    },
    formatDateTime(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${year}-${this.pad(month)}-${this.pad(day)}`;
    },
    checkHeaderCellStyle() {
      if (this.bj === '1') {
        return {textAlign:'center',background:'#FFFFFF',color:'#000000'};
      }
      return {textAlign:'center',background:'#283A4D',color:'#ffffff'};
    },
    checkCellStyle() {
      if (this.bj === '1') {
        return {textAlign:'center',background:'#FFFFFF',color:'#000000'};
      }
      return {textAlign:'center',background:'#283A4D',color:'#ffffff'};
    }
  }
};
</script>
<style>
/* ===== 面板自检弹窗全局样式覆盖 ===== */
.dev-check-dialog .el-dialog {
  margin-top: 6vh !important;
  background: #283A4D !important;
  border-radius: 16px;
  border: 1px solid #3A506B;
  height: 70vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.dev-check-dialog .el-dialog__header {
  padding: 18px 20px 12px 20px;
  background: #283A4D;
  flex-shrink: 0;
}

.dev-check-dialog .el-dialog__title {
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
}

.dev-check-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #8DA5BE;
}

.dev-check-dialog .el-dialog__headerbtn:hover .el-dialog__close {
  color: #0DA7C8;
}

.dev-check-dialog .el-dialog__body {
  padding: 0 20px 15px 20px;
  background: #283A4D;
  color: #ffffff;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.dev-check-dialog .el-dialog__footer {
  padding: 0 20px 20px 20px;
  border-top: none;
  background: #283A4D;
  flex-shrink: 0;
}

.dev-check-dialog.theme-light .el-dialog,
.dev-check-dialog.theme-light .el-dialog__header,
.dev-check-dialog.theme-light .el-dialog__body,
.dev-check-dialog.theme-light .el-dialog__footer {
  background: #FFFFFF;
  color: #000000;
}

.dev-check-dialog.theme-light .el-dialog {
  border: 1px solid #C8CDD4;
}

.dev-check-dialog.theme-light .el-dialog__title {
  color: #000000;
}

.dev-check-dialog.theme-light .el-dialog__headerbtn .el-dialog__close {
  color: #6B767E;
}

.dev-check-dialog.theme-light .el-dialog__headerbtn:hover .el-dialog__close {
  color: #0DA7C8;
}

.dev-check-dialog .el-table,
.dev-check-dialog .el-table__expanded-cell,
.dev-check-dialog .el-table th,
.dev-check-dialog .el-table tr,
.dev-check-dialog .el-table td {
  background: transparent;
}

.dev-check-dialog.theme-light .el-table,
.dev-check-dialog.theme-light .el-table__expanded-cell,
.dev-check-dialog.theme-light .el-table th,
.dev-check-dialog.theme-light .el-table tr,
.dev-check-dialog.theme-light .el-table td {
  background: #FFFFFF;
}

.dev-check-dialog.theme-light .el-table--border,
.dev-check-dialog.theme-light .el-table--group,
.dev-check-dialog.theme-light .el-table td,
.dev-check-dialog.theme-light .el-table th.is-leaf {
  border-color: #C8CDD4;
}

.dev-check-dialog .el-table--border,
.dev-check-dialog .el-table--group,
.dev-check-dialog .el-table td,
.dev-check-dialog .el-table th.is-leaf {
  border-color: #3A506B;
}

.dev-check-dialog .el-table::before {
  background-color: #3A506B;
}

.dev-check-dialog .el-table__row {
  cursor: pointer;
}

.dev-check-dialog .el-table td,
.dev-check-dialog .el-table th,
.dev-check-dialog .check-summary-row {
  user-select: text;
}

.dev-check-dialog .el-button--text {
  color: #0DA7C8;
}

.dev-check-dialog .el-button--text:hover {
  color: #3FC3DC;
}

.dev-check-dialog .frame-cell {
  user-select: text;
  cursor: text;
}

.dev-check-dialog.theme-light .el-table::before {
  background-color: #C8CDD4;
}

.dev-check-dialog .el-input__inner,
.dev-check-dialog .el-range-editor {
  background: #1A2838;
  border-color: #2E4056;
  color: #C0D8E8;
}

.dev-check-dialog.theme-light .el-input__inner,
.dev-check-dialog.theme-light .el-range-editor {
  background: #FFFFFF;
  border-color: #C8CDD4;
  color: #283A4D;
}

.dev-check-dialog .el-range-editor .el-range-input {
  background: transparent;
  color: #C0D8E8;
}

.dev-check-dialog.theme-light .el-range-editor .el-range-input {
  color: #283A4D;
}

.dev-check-dialog .el-range-editor .el-range-separator {
  color: #8DA5BE;
}

.dev-check-dialog.theme-light .el-range-editor .el-range-separator {
  color: #6B767E;
}

/* 分页器深色主题适配 */
.dev-check-dialog .el-pagination__total,
.dev-check-dialog .el-pagination__jump,
.dev-check-dialog .el-pager li,
.dev-check-dialog .el-pagination button,
.dev-check-dialog .el-pagination__editor {
  color: #C0D8E8;
}

.dev-check-dialog .el-pager li.btn-quicknext,
.dev-check-dialog .el-pager li.btn-quickprev {
  color: #C0D8E8;
}

.dev-check-dialog .el-pager li:hover,
.dev-check-dialog .el-pager li.active,
.dev-check-dialog .el-pagination button:hover {
  color: #0DA7C8;
}

.dev-check-dialog .el-pagination .el-input__inner {
  background: #1A2838;
  border-color: #2E4056;
  color: #C0D8E8;
}

.dev-check-dialog.theme-light .el-pagination__total,
.dev-check-dialog.theme-light .el-pagination__jump,
.dev-check-dialog.theme-light .el-pager li,
.dev-check-dialog.theme-light .el-pagination button,
.dev-check-dialog.theme-light .el-pagination__editor,
.dev-check-dialog.theme-light .el-pager li.btn-quicknext,
.dev-check-dialog.theme-light .el-pager li.btn-quickprev {
  color: #283A4D;
}

.dev-check-dialog.theme-light .el-pager li:hover,
.dev-check-dialog.theme-light .el-pager li.active,
.dev-check-dialog.theme-light .el-pagination button:hover {
  color: #0DA7C8;
}

.dev-check-dialog.theme-light .el-pagination .el-input__inner {
  background: #FFFFFF;
  border-color: #C8CDD4;
  color: #283A4D;
}
</style>
<style scoped>
.dialog-custom-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 5px;
}

.close-btn {
  padding: 8px 28px;
  border-radius: 8px;
  border: 1px solid #0dA7C8;
  background: transparent;
  color: #0dA7C8;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.close-btn:hover {
  background: #0dA7C8;
  color: #ffffff;
}

.check-dialog-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
  min-height: 0;
}

.check-filter-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.check-type-filter {
  width: 140px;
}

.check-summary-row {
  flex-shrink: 0;
  font-size: 13px;
}

.check-summary-ok {
  color: #67C23A;
}

.check-summary-err {
  color: #F56C6C;
  font-weight: bold;
}

.check-table-wrapper {
  height: calc(58vh - 66px);
  min-height: 0;
  overflow: hidden;
}

.check-pagination-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0;
  padding-top: 6px;
}

.check-pagination-row .el-pagination__sizes .el-input .el-input__inner {
  width: 80px;
}

.check-detail-title {
  color: #0DA7C8;
}
</style>



// WEBPACK FOOTER //
// src/dialog/diaDevCheck.vue